const overlay = document.querySelector(".js-overlay"),
    closeOverlay = document.querySelector(".js-overlay-close"),
    overlayVideoPlayer = document.querySelector(".js-overlay-video-player"),
    playPauseVideo = document.querySelector(".js-play-pause-video"),
    seekBar = document.querySelector(".js-seek-bar");

closeOverlay.addEventListener("click", (e) => {
    overlayVideoPlayer.pause();

    gsap.to(overlay, 0.3, {
        autoAlpha: 0,
        ease: Power1.easeInOut
    });

});

playPauseVideo.addEventListener("click", function () {
    if (overlayVideoPlayer.paused == true) {
        // Play the video
        overlayVideoPlayer.play();

        // Update the button text to 'Pause'
        playPauseVideo.innerHTML = "Pause";
    } else {
        // Pause the video
        overlayVideoPlayer.pause();

        // Update the button text to 'Play'
        playPauseVideo.innerHTML = "Play";
    }
});

seekBar.addEventListener("change", function () {
    // Calculate the new time
    var time = overlayVideoPlayer.duration * (seekBar.value / 100);

    // Update the video time
    overlayVideoPlayer.currentTime = time;
});

// Update the seek bar as the video plays
overlayVideoPlayer.addEventListener("timeupdate", function () {
    // Calculate the slider value
    var value = (100 / overlayVideoPlayer.duration) * overlayVideoPlayer.currentTime;

    // Update the slider value
    seekBar.value = value;
});

// Pause the video when the slider handle is being dragged
seekBar.addEventListener("mousedown", function () {
    overlayVideoPlayer.pause();
    playPauseVideo.innerHTML = "Play";
});

// Play the video when the slider handle is dropped
// seekBar.addEventListener("mouseup", function () {
//     overlayVideoPlayer.play();
// });
